import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ChangeDetectorRef, Component, inject, input, OnInit, signal } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { ColInterface } from '../common-list-table/col.interface';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-table-builder',
  imports: [
    TableModule,
    TagModule, 
    IconFieldModule, 
    InputTextModule, 
    InputIconModule, 
    MultiSelectModule,
    SelectModule,
    HttpClientModule,
    CommonModule,
    FormsModule
  ],
  templateUrl: './table-builder.component.html',
  styleUrls: ['./table-builder.component.scss']
})
export class TableBuilderComponent<T> implements OnInit {
  
  request = input.required<RequestHandler<T>>();
  
  columns = input.required<ColInterface[]>();

  selectColumns !: ColInterface[];

  loading = signal<boolean>(false);
  
  data = signal<T[]>([]);
  
  filterFields = signal<string[]>([]);

  cd = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadData();
    this.selectColumns = this.columns();
  }

  loadData(): void {
    this.loading.set(true);
    
    this.request().safePerform().response((response: T[] | T) => {
      this.data.set(Array.isArray(response) ? response : [response]);
      this.loading.set(false);
      this.cd.markForCheck();
    });
  }
}
